import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { CARD_BASE, SECTION_LABEL_CLASS } from '@/contabilidad/constants/ui';

interface SectionCardProps {
  title?: string;
  action?: ReactNode;
  className?: string;
  children: ReactNode;
}

export function SectionCard({ title, action, className, children }: SectionCardProps) {
  return (
    <div className={cn(CARD_BASE, className)}>
      {title && (
        <div className={cn('flex flex-wrap items-center gap-2 mb-3', action && 'justify-between')}>
          <p className={cn(SECTION_LABEL_CLASS, 'min-w-0')}>{title}</p>
          {action}
        </div>
      )}
      {children}
    </div>
  );
}
